var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "15",
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M1.4875 8.90531L7.13438 14.1772C7.36875 14.3959 7.67812 14.5178 8 14.5178C8.32187 14.5178 8.63125 14.3959 8.86563 14.1772L14.5125 8.90531C15.4625 8.02093 16 6.78031 16 5.48343V5.30218C16 3.11781 14.4219 1.25531 12.2688 0.895931C10.8438 0.658432 9.39375 1.12406 8.375 2.14281L8 2.51781L7.625 2.14281C6.60625 1.12406 5.15625 0.658432 3.73125 0.895931C1.57812 1.25531 0 3.11781 0 5.30218V5.48343C0 6.78031 0.5375 8.02093 1.4875 8.90531Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }